import React, { Suspense, lazy } from 'react';
const Flags = lazy(() => import('./components/Flags'));

export default function puzzle(props) {
  return (
    <Suspense fallback={<div />}>
      <Flags {...props} />
    </Suspense>
  );
}
